import { Caption, ParsingCaption } from "@/types/type";
import { replaceSilent, replaceText } from "./text-utils";

const formatTime = (sec: number) => {
  const hours = Math.floor(sec / 3600);
  const minutes = Math.floor((sec % 3600) / 60);
  const seconds = Math.floor(sec % 60);
  const milliseconds = sec * 10 % 10 * 100;
  
  const padZero = (num: number, length: number) => {
      return num.toString().padStart(length, '0');
  };
  return `${padZero(hours, 2)}:${padZero(minutes, 2)}:${padZero(seconds, 2)},${padZero(milliseconds, 3)}`;
}

const strByteLength = (s, b, i, c) => {
	// 원래는 한글 3바이트, 영문 1바이트이나, 바이트를 구하려는 목적이 아니라,
	// 자막 화면에서 길이를 조절하기 위함이므로 한글2, 영문1로
	for (b = i = 0; c = s.charCodeAt(i++); b += c >> 7 ? 2 : 1); // b += c >> 11 ? 3 : c >> 7 ? 2 : 1);
	return b;
};

const cutByLen = (text: string, maxByte: number) => {
	let b, i, c;
	for (b = i = 0; c = text.charCodeAt(i);) {
		b += c >> 7 ? 2 : 1; // b += c >> 11 ? 3 : c >> 7 ? 2 : 1;
		if (b > maxByte)
			break;
		i++;
	}
	return { cut: text.substring(0, i), left: text.substring(i, text.length - i) };
}

export const captionToSRT = (captions: Caption[]) => {
  let srtContent = '';
  captions.forEach((caption: Caption, index: number) => {
    srtContent += `${index + 1}\n`;
    srtContent += `${formatTime(caption.start)} --> ${formatTime(caption.end)}\n`;
    srtContent += `${caption.caption}\n\n`;
  });

  return srtContent.trim();
}

export const downloadSRT = (text: string, projectName: string) => {
  const blob = new Blob([text], { type: 'text/plain' });
  const url = URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = url;
  a.download = `${projectName}.srt`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

const captionGenerateTime = (time: string): number => {
  console.log("!@#!@#!@# time ", time);
  const parts = time.split(/[:,]/).map((part) => parseInt(part, 10));
  console.log("!@#!@#!@# parts ", parts);
  const seconds = parts[0] * 3600 + parts[1] * 60 + parts[2] + parts[3] / 1000; 
  console.log("!@#!@#!@# seconds ", seconds)
  return Math.round(seconds * 100) / 100;
};

/**
 * i += 4 인 이유
 * Line 1: Subtitle index
   Line 2: Time range (start --> end)
   Line 3: Subtitle text
   Line 4: Blank line separating entries
*/
export const parseSrtToJSON = (srtContent: string): ParsingCaption[] => {
  const lines = srtContent.split('\n');
  const subtitles = [];

  for (let i = 0; i < lines.length; i += 4) {
    const timeRange = lines[i + 1].trim().replace('-->', 'to');
    const text = lines[i + 2].trim();

    // Extract start and end times from the timeRange
    const [start, end] = timeRange.split(' to ').map((time) => captionGenerateTime(time));
    // subtitles.push({
    //   text,
    //   texts: { start, end },
    // });
    subtitles.push({
      caption: text,
      start,
      end
    });
  }

  console.log('>>>>> parseSrtToJson ', {subtitles})
  return subtitles;
}

const initCaptionObject = () => ({
  // ...captionObj,
	text: '',
  textLength: 0,
  texts: {
    start: 0,
    end: 0,
  },
});

const captionWithOrientation = (text: string) =>  {
	let textLengthLimit = 110;
	let txt = text.replace(/(&nbsp;|<([^>]+)>)/ig, '').trim().split(' ').filter(item => (item || '').trim() !== '');

	let caption = initCaptionObject();
	let captions = [caption];

  const checkCaptionLength = () => {
    if(!captions[captions.length -1 ]) return;
    let lastText = captions[captions.length - 1].text;
    if(lastText.length < textLengthLimit / 2 && captions.length > 1) {
      const prevText = captions[captions.length - 2].text.split(' ');

      for(let i = prevText.length -1; i > 0; i--) {
        let trimText = prevText[i].trim();
        if(trimText === '') {
          prevText.pop();
          continue;
        }
        let addedText = trimText + ' ' + lastText;
        if(strByteLength(addedText) < textLengthLimit / 1.5) {
          lastText = addedText;
          prevText.pop();
        } else break;
      } 

      captions[captions.length - 2].text = prevText.join(' ');
      captions[captions.length - 1].text = lastText;
    }
  }


  const pushWord = (word: string): any => {
    if(!word || word.trim() === '') return;
  
    const wordLength = strByteLength(word);
  
    const nextSubscript = () => {
      caption = initCaptionObject();
      captions.push(caption);
    }

    if(caption.textLength + wordLength < textLengthLimit) {
      caption.text += word + ' ';
      caption.textLength += wordLength + 1;
    } else {
      nextSubscript();
      return pushWord(word);
    }

    // 꽉 안차도 마침표 끝나면 다음 자막으로 보내기
    if(word.slice(-1) === '.' || word.slice(-1) === '。') {
      checkCaptionLength();
      nextSubscript();
    }
  }
  
  for(let val of txt) {
		const valLength = strByteLength(val);
    if(valLength > textLengthLimit) {
      let longWord = val;
      for(let i=0; i<valLength; i += textLengthLimit) {
        let cutVal = cutByLen(longWord, textLengthLimit - 2);
        pushWord(cutVal.cut);
        longWord = cutVal.left;
      }
    } else pushWord(val);
  }
  
  if(captions[captions.length - 1].text === '') captions.pop();
  checkCaptionLength();
  return captions;
}

//only 자막을 위한 처리에만 사용됨
export const makeTextClean = (text: string) => {
  let newText = replaceSilent(text);

  /**
   * @dewei
   * Script 상에서 문단은 <p> 태그로 구분되어 있고, html 태그 등을 삭제하는 과정에서 문단간 경계가 모호해짐.
   * 문단의 경계는 </p><p> 태그의 종료와 시작 부분으로 확인 할 수 잇음.
   * text replace를 통해 </p> <p> 로 수정 단계를 추가함.
   */

  const regxs = [
    { reg: /\&nbsp;/g, to: " " },
    { reg: /\<\/p\>\<p\>/g, to: "</p> <p>" },
    { reg: /\<[0-9a-zA-Z\s\=\"\-\_\n]+\>|\<\/[0-9a-zA-Z\s\=\"\-\_\n]+\>|\<[0-9a-zA-Z\s\=\"\-\_\n]+\/>/g, to: "" }
  ];

  for (const row of regxs) {
    newText = newText.replace(row.reg, row.to);
  }

  newText = newText.replace(/\|\./g, '').trim();

  return newText;
}

//only 자막을 위한 처리에만 사용됨
export const makeTextCleanForRender = (text: string) => {
  let newText = replaceSilent(text);

  /**
   * @dewei
   * Script 상에서 문단은 <p> 태그로 구분되어 있고, html 태그 등을 삭제하는 과정에서 문단간 경계가 모호해짐.
   * 문단의 경계는 </p><p> 태그의 종료와 시작 부분으로 확인 할 수 잇음.
   * text replace를 통해 </p> <p> 로 수정 단계를 추가함.
   */

  const regxs = [
    { reg: /\&nbsp;/g, to: " " },
    { reg: /\<\/p\>\<p\>/g, to: "</p> <p>" },
    { reg: /\<(?!effect\b)[0-9a-zA-Z\s\=\"\-\_\n]+\>|\<\/(?!effect\b)[0-9a-zA-Z\s\=\"\-\_\n]+\>|\<(?!effect\b)[0-9a-zA-Z\s\=\"\-\_\n]+\/>/g, to: "" }
  ];

  for (const row of regxs) {
    newText = newText.replace(row.reg, row.to);
  }

  newText = newText.replace(/\|\./g, '').trim();

  return newText;
}

/**
 * 자막 생성 함수
 */
export const makeSubtitle = ({ duration, texts }: { duration: number, texts: string}) => {
  if(!texts || !duration) return;

	let temp = [];
	let textsList = [];

	if(texts.includes('。')) {
		textsList = texts.split('。');
	} else {
		const fullStopRegex = new RegExp(/\.(\s)/g)
		textsList = texts.split(fullStopRegex);
	}

  for(let [i, text] of textsList.entries()) {
    // 줄 내림을 모두 없애고, 칸으로 만듦
    text = makeTextClean(text);

		if(!text.trim()) continue;

    let titles = captionWithOrientation(text);
    for(let idx in titles) {
      temp.push(titles[idx]);
    }
  }

  const filteredTemp = temp.filter((_temp) => _temp.text !== '. ')
  console.log('>>>>>> handleGenerateSubtitle text temp ', {temp}, {filteredTemp})
  return filteredTemp;
}

const strByteLengthNoSpace = (text: any): number => {
	return strByteLength(text.replace(/ /g, ""));
}

/**
 * 자막 시간 함수 - start, end
 */
export const makeSubtitleTime = ({ script, duration, tempo }: { script: any, duration: number, tempo: number }) => {
  let emptyAllDuration = 0;
  const allLength = strByteLengthNoSpace(script.map(e => e.text).join());
  const textAllLength = script.map(e => e.text).join();
  const textDuration = (duration / tempo) / textAllLength.length;

  script.forEach((_script) => {
    if(_script.text.replace(/ /g, "") && _script.duration) emptyAllDuration += _script.duration;
  });

  for(let [i, value] of script.entries()) {
    const subtitleTextLength = value.text.length;
    value.duration = Math.floor(textDuration * subtitleTextLength * 100) / 100;

    if( i === 0) {
      value.texts.start = 0;
      value.texts.end = value.duration;
    } else if( i === script.length - 1 ) {
      value.texts.start = script[i-1].texts.end;
      value.texts.end = value.texts.start + value.duration;
    } else {
      value.texts.start = script[i-1].texts.end;
      value.texts.end = Math.floor((value.texts.start + value.duration) * 100) / 100;
    }
  }
  return script;
}

/**
 * 자동화 위해 languageCode 받아온다
 */
export const getLangCode = (language: string): string => {
  return language === 'en'
  ? 'en-US'
  : language === 'ko'
  ? 'ko-KR'
  : language === 'zh'
  ? 'zh-CN'
  : language === 'ja'
  ? 'ja-JP'
  : language;
}